(function () {
  var AMOUNT = 200;

  var FORMATS = {
    'EUR': function (a) { return '€' + a; },
    'USD': function (a) { return '$' + a; },
    'GBP': function (a) { return '£' + a; },
    'CHF': function (a) { return 'CHF ' + a; },
    'CAD': function (a) { return 'CA$' + a; },
    'AUD': function (a) { return 'A$' + a; }
  };

  function formatAmount(code) {
    if (FORMATS[code]) return FORMATS[code](AMOUNT);
    return AMOUNT + ' ' + code;
  }

  function buildMessage() {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.__shopDefaultCurrency || 'EUR';
    return 'Free shipping on all orders over ' + formatAmount(code);
  }

  function updateSource() {
    var source = document.querySelector('.header__right-note-source');
    if (!source) return;
    source.innerHTML = buildMessage();
  }

  updateSource();

  document.addEventListener('DOMContentLoaded', updateSource);
  document.addEventListener('shopify:section:load', updateSource);
})();
